import GallerySection from "@/components/site/GallerySection";
import usePageTitle from "@/hooks/usePageTitle";

export default function GalleryPage() {
  usePageTitle("Gallery · Moments From the Two Holy Cities");
  return (
    <div data-testid="page-gallery">
      <section className="relative pt-32 md:pt-40 pb-12 md:pb-16 bg-white">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <span className="overline">Gallery</span>
          <h1 className="font-serif text-5xl md:text-7xl text-navy mt-3 leading-[1.02] tracking-tight max-w-3xl">
            Moments from the two holy cities.
          </h1>
        </div>
      </section>
      <GallerySection full />
    </div>
  );
}
